var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-checkbox-group', _vm._g(_vm._b({
    attrs: {
      "value": _vm.$attrs.value || []
    }
  }, 'el-checkbox-group', _vm.$attrs, false), _vm.$listeners), [_vm.$attrs.options ? _vm._l(_vm.$attrs.options, function (item) {
    return _c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }) : _vm._e()], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };